import { FormGroup } from "@angular/forms";
import { obtenerSolicitudTipoId } from "src/app/core/models/request/afiliaciones/solicitud-tipos.enum";
import { ObligatoriedadDocumentosService } from "src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { DocumentosParentesco } from "./documentos-parentesco";

export class DocumentosTrabajador extends DocumentosParentesco {
    constructor(personaControl: FormGroup, formulario: FormGroup, documentosService: ObligatoriedadDocumentosService) {
                super(personaControl, formulario, documentosService);
            }
            
    async obtenerDocumentos() {
        const edad = this.calcularEdad(this.personaControl.getRawValue().FechaNaciTrabajador);

        const filtro = {
            solicitudesTiposId: obtenerSolicitudTipoId(this.datosAdicionales.solicitudId),
            parentescosNombre: 'TITULAR',
            edad,
            aplicaDiscapacidad: false,
            reglas: { 
                parentesco: "TITULAR"
            }
        };

        this.documentosService.documentosTitular = await this.documentosService.obtenerDocumentosFiltrados(filtro);
    }
}
